export enum ProductGroupPublicationScopeEnum {
  OWN_PRODUCTS = '1',
  INCLUDE_3RD_PARTY_PRODUCTS = '2',
}

export const ProductGroupPublicationScope = [
  { label: '自社商品のみ', value: ProductGroupPublicationScopeEnum.OWN_PRODUCTS },
  {
    label: '他社商品(買取)を含める',
    value: ProductGroupPublicationScopeEnum.INCLUDE_3RD_PARTY_PRODUCTS,
  },
];
